import routes from '@/services/api/api'
import axios from 'axios'

/**
 * @description
 * Login  user request
 * 
 * @param {oject} params
 * @return {Promise} user data, null in otherwise
 */
const modulesRequest = async function() {
    return new Promise((resolve, reject) => {
        axios({
            url: routes.MODULES_REQUEST,
            data: {},
            method: 'GET',
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    }) // end promise
} // end function

export { modulesRequest }